import React, { useState, useEffect } from 'react';
import { Warning } from '@indeed/ifl-icons';
import Modal from 'Components/Modal';
import { SuccessAlert } from 'Components/Notifications/Notifications';
import { ALERT_TIMEOUT } from 'Constants/Alert';
import RemoteSyncUtil from 'Utils/RemoteSyncUtil';
export const ErrorModal = ({ onRefresh, onDismiss }) => (React.createElement(Modal, { icon: React.createElement(Warning, { "aria-hidden": true }), title: "\u4FDD\u5B58\u306B\u5931\u6557\u3057\u307E\u3057\u305F", description: "\u4FDD\u5B58\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u3092\u78BA\u8A8D\u306E\u4E0A\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002", buttonText: "\u3082\u3046\u4E00\u5EA6\u4FDD\u5B58\u3059\u308B", cancelText: "\u30AD\u30E3\u30F3\u30BB\u30EB", onClickButton: onRefresh, onClickCancel: onDismiss }));
const getAlertType = (state) => {
    switch (state) {
        case 'error':
            return 'error';
        case 'synced':
            return 'success';
        default:
            return 'hidden';
    }
};
const SyncAlert = ({ alertType }) => {
    const [type, setType] = useState(getAlertType(RemoteSyncUtil.instance().getState()));
    const handleDismiss = () => setType('hidden');
    const syncUtil = RemoteSyncUtil.instance();
    useEffect(() => {
        const listener = (state) => {
            const alertType = getAlertType(state);
            setType(alertType);
            if (alertType === 'success') {
                setTimeout(() => {
                    if (getAlertType(syncUtil.getState()) !== 'error') {
                        setType('hidden');
                    }
                }, ALERT_TIMEOUT);
            }
        };
        syncUtil.listen(listener);
        return () => syncUtil.removeListener(listener);
    }, [syncUtil]);
    switch (type) {
        case 'success':
            return React.createElement(SuccessAlert, { alertType: alertType, onDismiss: handleDismiss });
        case 'error':
            return (React.createElement(ErrorModal, { onRefresh: () => window.location.reload(), onDismiss: handleDismiss }));
        default:
            return null;
    }
};
export default SyncAlert;
